import { createSelector } from '@ngrx/store';
import { selectFeature } from '../../store/admin.selectors';

const selectIntegrationManagev2Feature = createSelector(selectFeature, (state) => state.integrationManagev2State);

export const selectIntegrationManagev2Filenames = createSelector(
    selectIntegrationManagev2Feature,
    (state) => state.filenames
);

export const selectIntegrationManagev2FileContent = createSelector(
    selectIntegrationManagev2Feature,
    (state) => state.fileContent
);

export const selectIntegrationManagev2Lookups = createSelector(
    selectIntegrationManagev2Feature,
    (state) => state.integrationLookup
);

export const selectIntegrationManagev2IsLoading = createSelector(
    selectIntegrationManagev2Feature,
    (state) => state.isLoading
);

export const selectIntegrationManagev2IsSaving = createSelector(
    selectIntegrationManagev2Feature,
    (state) => state.isSaving
);

export const selectIntegrationManagev2Filename = createSelector(
    selectIntegrationManagev2Feature,
    (state) => state.filename
);

export const selectVersionList = createSelector(selectIntegrationManagev2Feature, (state) => state.versions);

export const selectSelectedVersion = createSelector(selectIntegrationManagev2Feature, (state) => state.selectedVersion);

export const selectVersions = createSelector(selectVersionList, selectSelectedVersion, (versions, selectedVersion) => ({
    versions,
    selectedVersion
}));

export const selectPublishedVersions = createSelector(
    selectIntegrationManagev2Feature,
    (state) => state.publishedVersions
);

export const IntegrationManagev2Selectors = {
    selectIntegrationManagev2Filenames,
    selectIntegrationManagev2FileContent,
    selectIntegrationManagev2Lookups,
    selectIntegrationManagev2IsLoading,
    selectIntegrationManagev2IsSaving,
    selectIntegrationManagev2Filename,
    selectVersions,
    selectPublishedVersions
};
